import Vue from 'vue'
import Promise from 'es6-promise';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookie from 'vue-cookie'
import globalConfig from 'common/js/GlobalConfig';
import layer from 'common/lib/layer/layer';

require('es6-promise').polyfill();
Vue.use(VueAxios, axios);

Vue.axios.defaults.withCredentials = true;

Vue.axios.interceptors.request.use(
  config => {
    if (localStorage.getItem(globalConfig.STORAGE_TOKEN_NAME)) {
      config.headers.Authorization = 'Bearer ' + localStorage.getItem(globalConfig.STORAGE_TOKEN_NAME);
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

Vue.axios.interceptors.response.use(
  response => {
    let cookieToken = VueCookie.get(globalConfig.COOKIE_TOKEN_NAME);
    if (cookieToken) {
      let stoken = localStorage.getItem(globalConfig.STORAGE_TOKEN_NAME);
      if(cookieToken != stoken) {
        localStorage.setItem(globalConfig.STORAGE_TOKEN_NAME, cookieToken);
      }
      VueCookie.delete(globalConfig.COOKIE_TOKEN_NAME);
    }
    return response;
  },
  err => {
    return Promise.reject(err);
  });

export default {
  ie9 () {
    return (navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.match(/9./i) == "9.");
  },
  get(url, callback,config){
    if (this.ie9()) {
      return;
    } else {
      Vue.axios.get(url,config)
        .then((response) => {
          if(response.data.code == 1){
            console.log("need put doAfterSyncLogin => "+url);
          }
          this.dealResult(response, callback);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
    getBlob(url, callback){
        if (this.ie9()) {
            return;
        } else {
            Vue.axios.get(url,{responseType:'blob'})
                .then((response) => {
                    if(response.data.code == 1){
                        console.log("need put doAfterSyncLogin => "+url);
                    }
                    this.dealResult(response, callback);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
  doPost(url,data,callback){
    return axios({
      method: 'post',
      url,
      data: JSON.stringify(data),
      timeout: 30000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
        "Authorization": 'Bearer ' + localStorage.getItem(globalConfig.STORAGE_TOKEN_NAME)
      }
    }).then((response) => {
      if(response.data.code == 1){
        console.log("need put doAfterSyncLogin => "+url);
      }
      this.dealResult(response, callback);
    })
      .catch((error) => {
        console.log(error);
      });
  },
  post(url, data, callback){
    if (this.ie9()) {
      return;
    } else {
      var qs = require('qs');
      Vue.axios.post(url, qs.stringify(data), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          "Authorization": 'Bearer ' + localStorage.getItem(globalConfig.STORAGE_TOKEN_NAME)
        }
      })
        .then((response) => {
          if(response.data.code == 1){
            console.log("need put doAfterSyncLogin => "+url);
          }
          this.dealResult(response, callback);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  postMulti(url, form, callback, uploadProgressHandler){
      var options = {method: 'post', headers: {'Content-Type': 'multipart/form-data'} };
      if(uploadProgressHandler) {
          options.onUploadProgress = uploadProgressHandler;
      }
      Vue.axios.post(url, form, options).then((response) => {
          this.dealResult(response, callback)
      }).catch((error) => {
          console.log(error)
      })
  },
  dealResult(response, callback){
    if (response.data.code == 1) {
      if(globalConfig.defaultLoginType == 1){//跳转到account登录页面
        window.location.href = globalConfig.domain.forensicsWebOp + "/login.html?returnURL=" + encodeURIComponent(location.href);
      } else if(globalConfig.defaultLoginType==2){//弹出登录框登录
        layer.open({
          type: 2,
          title: false,
          icon:2,
          closeBtn: 0,
          area: ['400px','480px'],
          fixed: false, //不固定
          content: [globalConfig.domain.accountWeb
          +'/plogin/loginPage?corsUrl='
          +encodeURIComponent(globalConfig.domain.athenaWebUms+"/login-cors.html"),'no'],
          success: function () {
            $(".layui-layer-iframe,.layui-layer-content").css("border-radius", "10px");
          }
        });
      }
    } else {
      callback(response);
    }
  }
}




// WEBPACK FOOTER //
// ./src/common/js/http.js